import { onMount } from 'svelte';
import { writable, derived } from 'svelte/store';

export default function useMediaQuery(query, defaultValue = true) {
  const store = writable(defaultValue);

  onMount(() => {
    const mediaQueryList = window.matchMedia(query);
    store.set(mediaQueryList.matches);
    const listener = (event) => store.set(event.matches);
    mediaQueryList.addEventListener('change', listener);
    return () => mediaQueryList.removeEventListener('change', listener);
  });

  // Returning a derived store to prevent outsiders from overwriting the original value.
  return derived(store, (matches) => matches);
}
